import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError, catchError } from 'rxjs';
import { GlobalErrorHandlerService } from '../error-service/global-error-handler.service';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {

  constructor(private errorHandler: GlobalErrorHandlerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => error);
      })
    );
  }
}
